export { default as TabHeaderDetail } from './Detail.tab';
export { default as TabHeaderBank } from './Bank.tab';
